<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Investments / Other Income</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">HRM</li>
          <li class="breadcrumb-item" aria-current="page">Investments</li>
        </ol>
      </nav>
    </div>
    <div class="head-icons ms-2">
      <!--<h2>1/3</h2>-->
    </div>
  </div>
  <!-- /Breadcrumb -->
  <ul class="nav nav-tabs nav-tabs-solid bg-transparent border-bottom mb-3">
    <li class="nav-item">
      <button
        [ngClass]="{ 'nav-link': true, active: activeChild === 'declare' }"
        (click)="renderChild('declare')"
      >
        Declare
      </button>
    </li>
    <li class="nav-item">
      <button
        [ngClass]="{ 'nav-link': true, active: activeChild === 'tax' }"
        (click)="renderChild('tax')"
      >
        Tax
      </button>
    </li>
  </ul>

  <div [ngSwitch]="activeChild">
    <ng-container *ngSwitchCase="'declare'">
      <app-declare></app-declare>
    </ng-container>

    <ng-container *ngSwitchCase="'tax'">
      <app-tax-calculation-details></app-tax-calculation-details>
    </ng-container>
  </div>
</div>
